<template>
  <div
  class="crx-input mod-parent">

    <v-menu
    ref="bestBeforeMenu"
    :close-on-content-click="false"
    v-model="bestBeforeMenu"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    min-width="290px"
    >

      <template v-slot:activator="{ on }">
        <v-btn
          icon
          small
          v-on="on"
        >
          <v-icon
          small
          :color="dateValid? 'blue-grey darken-2' : 'blue-grey lighten-4'">
            event
          </v-icon>
        </v-btn>
      </template>

      <v-date-picker v-model="pickerDate" @input="bestBeforeMenu = false" no-title color="color1"></v-date-picker>

    </v-menu>

    <the-mask 
    mask="##/##/####" 
    type="text" 
    :masked="true" 
    v-model="textDate"
    placeholder="dd/mm/yyyy"
    @focus.native="focussed = true"
    @blur.native="onBlur">
    </the-mask>

  </div>
</template>

<script>
import {TheMask} from 'vue-the-mask'

export default {
  props: ['date'],
  components: {TheMask},
  data () {
    return {
      focussed: false,
      textDate: null,
      pickerDate: null,
      bestBeforeMenu: false,
      showBorder: true
    }
  },
  computed: {
    dateValid () {
      return this.$moment(this.textDate, 'DD/MM/YYYY', true).isValid()
    }
  },
  watch: {
    date: {
      immediate: true,
      handler (nv) {
        // this is exactly as your db will give it to you
        if (this.$moment(nv, 'YYYY-MM-DDTHH:mm:ss.SSS[Z]', true).isValid()) {
          this.textDate = this.$moment(nv, 'YYYY-MM-DD').format('DD/MM/YYYY')
        }
        if (!this.focussed) {
          // triggered when using picker
          if (this.$moment(nv, 'YYYY-MM-DD', true).isValid()) {
            this.textDate = this.$moment(nv, 'YYYY-MM-DD').format('DD/MM/YYYY')
          }
        }

        var minDate = this.$moment('1000-01-01', 'YYYY-MM-DD')
        if (this.$moment(nv, 'YYYY-MM-DD', true).isValid() && this.$moment(nv, 'YYYY-MM-DD', true).isAfter(minDate)) {
          this.pickerDate = nv
        }
      }
    },
    textDate: {
      handler (nv) {
        if (this.$moment(nv, 'DD/MM/YYYY', true).isValid()) {
          this.$emit('update:date', this.$moment(nv, 'DD/MM/YYYY').format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'))
        } else {
          this.$emit('update:date', null)
        }
      }
    },
    pickerDate: {
      handler (nv) {
        this.$emit('update:date', nv)
      }
    }
  },
  methods: {
    onBlur () {
      this.focussed = false
      // this will clear whats left in the text field when blurring if invalid e.g. "5/"
      if (!this.$moment(this.textDate, 'DD/MM/YYYY', true).isValid()) {
        this.textDate = null
      }
    },
    showMenu () {
      this.bestBeforeMenu = true
    }
  }
}
</script>

<style scoped>
.mod-parent {
  flex-direction: row;
  align-items: center;
}
</style>
